module.exports = __webpack_public_path__ + "static/rob-family-logo-0825595a17d88bf3a6d47ada8ca0ce0e.png";